
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[language]/[[...slug]]",
      function () {
        return require("private-next-pages/[language]/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[language]/[[...slug]]"])
      });
    }
  